import type Matter from '../../entities/matter';
import type {MatterContingency} from '../../entities/matter';

/** The terms a contingency Case starts with (CTG-002). */
export const DEFAULT_CONTINGENCY: Readonly<MatterContingency> = Object.freeze({
    judgement: 0,
    commissionPercentage: 33,
    clientPaysExpenses: false,
    retainerFee: 0
});

/**
 * Give a contingency Case the default terms when it has none yet. The Matter constructor always
 * sets contingency to {}, which is truthy, so "has none" means no keys (OWA-1601). Terms the user
 * already set, including a commission of zero, are kept.
 */
export function applyContingencyDefaults(matter: Matter): Matter {
    const hasTerms = !!matter.contingency && Object.keys(matter.contingency).length > 0;

    if (matter.rateType?.includes('c') && !hasTerms) matter.contingency = {...DEFAULT_CONTINGENCY};

    return matter;
}

/**
 * The number typed into a contingency input, or null when it is empty or not a number. Storing
 * Number.parseFloat('') would put NaN on the Case (OWA-1601).
 */
export function parseContingencyInput(text: string): number | null {
    const value = Number.parseFloat(text);

    return Number.isFinite(value) ? value : null;
}
